import { post , get} from "@/utils/http";
console.log(get)
// 本地开发的默认前缀  127.0.0.1:8082/ ， 不需要单独添加， 如果转测试 去http.js 文件中修改前缀  http://127.0.0.1:8082/cubcmsc/statements/getCurrentBillStatNo
class setTing {
    //查询我的信用额度
    getCustomerCredit(parme) {
        return post(
            'customer/getCustomerCredit', parme
        )
    }
    //根据客户编码查询零担快递合同信息
    queryCustomerContracts(parme) {
        return post(
            'customer/queryCustomerContracts', parme
        )
    }

    //根据客户编码查询客户名下所有的联系人信息
    queryContactByCustomer() {
        return post(
            'clientManagement/queryContactByCustomer', {}
        );
    }

    //获取手机验证码
    getVerificationCode(param, type) {
        return post(
            'clientManagement/getVerificationCode', { param: param, type: type }
        );
    }

    //获取邮箱验证码
    getEmailVerificationCode(param) {
        return post(
            'clientManagement/getEmailVerificationCode', { email: param }
        );
    }

    //校验验证码
    checkVerCode(param) {
        return post(
            'clientManagement/checkVerCode', param
        );
    }

    //新增账号
    addNewContact(linkMan, phoneNumber, verCode) {
        return post(
            'clientManagement/addNewContact', { linkMan: linkMan, phoneNumber: phoneNumber, type: "P", verCode: verCode }
        );
    }
    //更新账号
    updateContactInfo(param) {
        return post(
            'clientManagement/updateContactInfo', param
        );
    }


    //删除账号
    deleteContactInfo(id) {
        return post(
            'clientManagement/deleteContactInfo', { id: id }
        );
    }

    // 查询模板:/template/查询模板:/template/selectCustomTemplate
    selectCustomTemplate(param) {
        return post('template/selectCustomTemplate', param)
    }
    // 新增或修改模板
    updateTemplate(param) {
        return post('template/updateTemplate', param)
    }
    //  设置默认模板
    updateIsTemplate(param) {
        return post('template/updateIsTemplate', param)
    }
    // 删除模板
    deleteTemplate(param) {
        return post('template/deleteTemplate', param)
    }

    // 查询客户银行账号列表
    getPaymentList(params) {
        return post('statements/queryCmcContractPaymentList', params)
    }

    // 新增银行账号
    addPayment(param) {
        return post('statements/addCmcContractPaymentInfo', param)
    }

    // 修改银行账号
    updatePayment(param) {
        return post('statements/updateCmcContractPaymentInfo', param)
    }

    // 删除银行账号
    deletePayment(param) {
        return post('statements/deleteCmcContractPaymentInfo', param)
    }
}

export default setTing